export const buildingDocumentCategoryConstants = {
  BASE_PATH: '/v1/building_profile/account-id/building_document_categories',
  GET_BUILDING_DOCUMENT_CATEGORIES: 'GET_BUILDING_DOCUMENT_CATEGORIES',
  SET_BUILDING_DOCUMENT_CATEGORY_LOADING: 'SET_BUILDING_DOCUMENT_CATEGORY_LOADING',
  UPDATE_BUILDING_DOCUMENT_CATEGORY: 'UPDATE_BUILDING_DOCUMENT_CATEGORY',
  DELETE_BUILDING_DOCUMENT_CATEGORY: 'DELETE_BUILDING_DOCUMENT_CATEGORY',
};
